import { useContext, useEffect } from "react"
import { UserContext } from "@context"
import { AuthError } from "@components"
import { useNavigate } from "react-router-dom"

const Verify = () => {
  const navigate = useNavigate()
  const { error, user, loading } = useContext(UserContext)

  useEffect(() => {
    if (!loading && user) {
      navigate('/', { replace: true })
    }
  }, [error, user, loading, navigate])
  
  if (error) {
    return <AuthError />
  }

  return null
}

export default Verify